<div
  class="flex align-items-center justify-content-between cursor-pointer"
  pStyleClass="@next"
  enterFromClass="hidden"
  enterActiveClass="scalein"
  leaveToClass="hidden"
  leaveActiveClass="fadeout"
  [hideOnOutsideClick]="true"
>
  <div class="flex align-items-center justify-content-center">
    <div
      class="h-2rem w-2rem bg-primary text-white border-round flex align-items-center justify-content-center"
    >
      <i class="fa fa-money-bill"></i>
    </div>
    <div class="ml-3">
      <h4 class="text-base mb-0 line-height-1 font-bold">
        {{ 'TRANSACTION.PAYMENTS' | translate }}
      </h4>
      @if (!loading && paymentData$ | async) {
        <p class="mb-0 text-xs text-600">
          {{ (paymentData$ | async).length | number }}
          {{ 'TRANSACTION.PAYMENTS_GENE' | translate }}
        </p>
      }
      @if (loading) {
        <p-skeleton width="7rem" height="0.9rem" styleClass="mt-1" />
      }
    </div>
  </div>
  <!-- <i class="fa fa-circle-chevron-down text-primary"></i> -->
  @if (showAddCreditButton) {
    <div class="flex align-items-center justify-content-end">
      <p-button
        (click)="addCreditSidebar = true"
        styleClass="p-button-outlined text-sm mr-3"
        [label]="'CREDIT_BALANCE.ADD_CREDIT' | translate"
        icon="fa fa-dollar"
      />
      <i class="fa fa-circle-chevron-down text-primary"></i>
    </div>
  }
</div>

<div class="hidden mt-2">
  <app-data-grid
    [columnData]="paymentData$"
    [columns]="paymentTablecolumns$"
    [selectable]="selecallInvoiceData"
    [totalRecords]="totalRecordLength"
    (emitValue)="handleEvent($event)"
    (emitSelectValue)="handleSelectAll($event)"
    (loadNextData)="fetchNextSetData($event)"
    (onAction)="onPaymentActionEvent($event)"
    [paginator]="true"
    [EmptyState]="emptyStateComponent$"
    [loading]="loading"
    [gridName]="'payment-list'"
  />
</div>

<!-- Payment Modal  -->
@if (showPaymentPopup | async) {
  <p-dialog
    [visible]="showPaymentPopup"
    (onHide)="closePaymentPopup()"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '767px': '100vw' }"
    [style]="{ width: '820px' }"
    styleClass="no-header-modal"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">
          {{ 'PAYMENT.PAYMENTS_TTTLE' | translate
          }}<strong> {{ paymentDetails.number_prefix }}</strong>
        </h2>

        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center mr-3">
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="printPaymentPDF()"
            >
              <i class="fa fa-print"></i>
            </span>
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="SendPaymentPdf('Email')"
            >
              <i class="fa fa-envelope"></i>
            </span>
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="SendPaymentPdf('WhatsApp')"
            >
              <i class="fab fa-whatsapp"></i>
            </span>
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="SendPaymentPdf('MobileNotification')"
            >
              <i class="fa fa-bell"></i>
            </span>
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="downloadPaymentPDF()"
            >
              <i class="fa fa-download"></i>
            </span>
            @if (paymentDetails.status.toLowerCase() !== 'void') {
              <span
                class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
                (click)="moreInfo.toggle($event)"
              >
                <i class="fa fa-ellipsis-v"></i>
              </span>
            }
            <p-popover
              #moreInfo
              styleClass="overflow-hidden -ml-8 text-sm w-11rem"
            >
              <ng-template #content>
                <ul class="list-none -m-4 px-0 py-1 text-xs text-600">
                  <li
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    (click)="showVoidPaymentModal = true"
                  >
                    <i class="fa fa-ban text-500 mr-2"> </i
                    >{{ 'ADMIN.COMMON.VOID' | translate }}
                  </li>
                </ul>
              </ng-template>
            </p-popover>
          </div>
          <div
            class="fa fa-times text-600 cursor-pointer"
            (click)="closePaymentPopup()"
          ></div>
        </div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 p-3">
        <pdf-viewer
          [src]="pdfSrc | async"
          [render-text]="true"
          [original-size]="false"
          style="width: 100%; height: 500px"
        />
      </div>
      <!-- Content -->
    </ng-template>
  </p-dialog>
}
<!-- Payment Modal -->

<!-- Void Payment Modal -->
<p-dialog
  [visible]="showVoidPaymentModal"
  (onHide)="showVoidPaymentModal = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '630px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form [formGroup]="voidPaymentForm">
      <div class="relative text-center p-4">
        <div
          class="fa fa-times opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidPaymentModal = false"
        ></div>

        <img
          width="160"
          class="block mx-auto"
          src="/assets/img/void-invoice-img.svg"
          alt="Image"
        />

        <h4 class="text-base md:text-lg my-3 font-bold">
          {{ 'PAYMENT.PAYMENT_DEL_CONFI' | translate }} <br />
          {{ paymentDetails.number_prefix }} ?
        </h4>
        <p class="text-600 md:w-26rem mx-auto mb-0">
          {{ 'PAYMENT.PAYMENT_DEL_INFO' | translate }}
        </p>
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'PAYMENT.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reason"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (VoidReasonFormControl.touched && VoidReasonFormControl.invalid) {
          <app-error-msg
            [errors]="VoidReasonFormControl.errors"
            [fieldLabel]="'INVOICE.REASON_REQUIRED' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm"
          (click)="showVoidPaymentModal = false"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'PAYMENT.VOID_LABEL' | translate"
          class="p-button-danger text-sm"
          [loading]="btnLoading | async"
          (click)="deletePayment(voidPaymentForm)"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Void Payment Modal -->

@if (addCreditSidebar) {
  <credit-balance-sidebar
    [visible]="addCreditSidebar"
    (onHide)="closeDialog()"
    [clientId]="clientId()"
    [tenantId]="tenantId()"
    closeOnEscape="false"
    (closeSidebar)="closeSidebar($event)"
  />
}

@if (showRefund | async; as showPopup) {
  <fitness-force-process-refund
    [showRefundModal]="showPopup"
    [IsMinimumPaymentRequired]="true"
    [refundData]="refundData"
    (closeDialog)="closeRefundDialogEvent($event)"
  />
}

<!-- Void Payment Modal -->
<p-dialog
  [visible]="showVoidPaymentModal"
  (onHide)="showVoidPaymentModal = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '630px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form [formGroup]="voidPaymentForm">
      <div class="relative text-center p-4">
        <div
          class="fa fa-times opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidPaymentModal = false"
        ></div>

        <img
          width="160"
          class="block mx-auto"
          src="/assets/img/void-invoice-img.svg"
          alt="Image"
        />

        <h4 class="text-base md:text-lg my-3 font-bold">
          {{ 'PAYMENT.PAYMENT_DEL_CONFI' | translate }} <br />
          {{ paymentDetails.number_prefix }} ?
        </h4>
        <p class="text-600 md:w-26rem mx-auto mb-0">
          {{ 'PAYMENT.PAYMENT_DEL_INFO' | translate }}
        </p>
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'PAYMENT.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reason"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (VoidReasonFormControl.touched && VoidReasonFormControl.invalid) {
          <app-error-msg
            [errors]="VoidReasonFormControl.errors"
            [fieldLabel]="'INVOICE.REASON_REQUIRED' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm"
          (click)="showVoidPaymentModal = false"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'PAYMENT.VOID_LABEL' | translate"
          class="p-button-danger text-sm"
          (click)="deletePayment(voidPaymentForm)"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Void Payment Modal -->

<!-- Payment Modal  -->
@if (showPaymentPopup | async) {
  <p-dialog
    [visible]="showPaymentPopup"
    (onHide)="closePaymentPopup()"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '767px': '100vw' }"
    [style]="{ width: '820px' }"
    styleClass="no-header-modal"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-base md:text-lg font-normal">
          {{ 'PAYMENT.PAYMENTS_TTTLE' | translate
          }}<strong> {{ paymentDetails.number_prefix }}</strong>
        </h2>

        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center mr-3">
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="printPaymentPDF()"
            >
              <i class="fa fa-print"></i>
            </span>
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="SendPaymentPdf('Email')"
            >
              <i class="fa fa-envelope"></i>
            </span>
            <span
              class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
              (click)="downloadPaymentPDF()"
            >
              <i class="fa fa-download"></i>
            </span>
            @if (paymentDetails.status.toLowerCase() !== 'void') {
              <span
                class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
                (click)="moreInfo1.toggle($event)"
              >
                <i class="fa fa-ellipsis-v"></i>
              </span>
            }

            <p-popover
              #moreInfo1
              styleClass="overflow-hidden ml-9 text-sm w-11rem"
            >
              <ng-template #content>
                <ul class="list-none -m-4 px-0 py-1 text-xs text-600">
                  <li
                    class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                    (click)="showVoidPaymentModal = true"
                  >
                    <i class="fa fa-ban text-500 mr-2"> </i
                    >{{ 'ADMIN.COMMON.VOID' | translate }}
                  </li>
                </ul>
              </ng-template>
            </p-popover>
          </div>
          <div
            class="fa fa-times text-500 cursor-pointer"
            (click)="closePaymentPopup()"
          ></div>
        </div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 p-3">
        <pdf-viewer
          [src]="pdfSrc | async"
          [render-text]="true"
          [original-size]="false"
          style="width: 100%; height: 500px"
        />
      </div>
      <!-- Content -->
    </ng-template>
  </p-dialog>
}
<!-- Payment Modal -->
